module.exports = __webpack_public_path__ + "static/img/newsBanner.13b633b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/newsBanner.jpg
// module id = y3EJ
// module chunks = 15